// utils/getMacFromState.js

import { getMacRegion } from "./macRegions";

export function getMacFromState(stateInput) {
  if (!stateInput) return null;
  return getMacRegion(stateInput)?.macName || null;
}
